import  { useState, useEffect, useRef} from 'react';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { useAppContext } from "../../Lib/contextLib";
import { getVideo, GetUserVideo } from '../../s3Func/s3Download';
import Amplify, { API, Auth } from 'aws-amplify';
import PopUp from '../../Popup/logoutPopup';
import {CloudfrontVideoFormat} from '../../videos/CloudfrontVideoFormat';
import './Module11World.css';
import '../../Animations.css';
import Draggable from 'react-draggable';

import Learn from './../../Learn/Learn'
import Practice from "./Practice";
import SingingTime from "./../../SingingTime/SingingTime";
import Celebrate from "./../../Celebrate/Celebrate";
import Surprise from "./../../SurpriseVideo/surprise"
import FollowTheBeatModule6 from "./../../FollowTheBeat/FollowTheBeatModule6.js"
import presentSound from "./../../Unit1/Module1/assets/ta_da_gift.mp3"
import loading from "./../../loading-gif-png-5.gif"

let Module11World = () => {
    const [clientHeight, setVh] = useState(window.innerHeight);
    const [clientWidth, setVw] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => {
            setVh(window.innerHeight)
            setVw(window.innerWidth)
        }
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
        
      }, [clientHeight, clientWidth]);


    const { userHasAuthenticated } = useAppContext();
    const dispatch = useDispatch()
    const { module11 } = useSelector((state) => state.module11, shallowEqual,);
    const { login } = useSelector((state) => state.loginReducer, shallowEqual);
    const [isOpen, setIsOpen] = useState(false);
    let navigate = useNavigate();
    const generateImageUrl = (baseUrl) => login.cloudFront + baseUrl + login.cookie;

    let background = generateImageUrl('images/Module11Images/Unit3_Mod1_Background-1.png');
    let closedChest6 = generateImageUrl('images/Module1Images/Chest_Closed.svg');
    let openChest = generateImageUrl('images/Module1Images/Chest_Open.svg');
    let animal = generateImageUrl('images/Module1Images/Crab.svg');
    let crab = generateImageUrl('images/Module1Images/Crab2.gif');
    let progressbar0 = generateImageUrl('images/Module1Images/ProgressBar_0.svg');
    let progressbar1 = generateImageUrl('images/Module1Images/ProgressBar_1-4.svg');
    let progressbar2 = generateImageUrl('images/Module1Images/ProgressBar_2-4.svg');
    let progressbar3 = generateImageUrl('images/Module1Images/ProgressBar_3-4.svg');
    let progressbarCompleted = generateImageUrl('images/Module1Images/ProgressBar_Completed.svg');
    let coinPick = generateImageUrl('images/Images/AwesomeCoin.png');
    let coinBar = generateImageUrl('images/Images/Coin+Counter.png');
    let journeyImage = generateImageUrl('images/Module1Images/bluejourneymap.svg');
    let logoutBtn = generateImageUrl('images/Module1Images/Logout.png');
    let reviewBtn = generateImageUrl('images/Module1Images/Button_Review.png');
    let rewardBtn = generateImageUrl('images/Module1Images/Button_Reward_3x.png')
    let celebrateBtn = generateImageUrl('images/Module1Images/Button_Celebrate.png');
    let learnBtn = generateImageUrl('images/Module1Images/Button_Learn.png');
    let practiceBtn = generateImageUrl('images/Module1Images/Button_Practice.png');
    let ftbBtn = generateImageUrl('images/Images/Button_FTB.svg');
    let keyReward = generateImageUrl('images/Module1Images/Key_Full.png');
    let SurfBoardBlue = generateImageUrl('images/Module1Images/Reward_SurfBoardBlue.svg');
    let SurfBoardRed = generateImageUrl('images/Module1Images/Reward_SurfBoardRed.svg');
    let CoralRed = generateImageUrl('images/Module6Images/DailyReward_CoralRed.png');
    let CoralBlue = generateImageUrl('images/Module6Images/DailyReward_CoralBlue.png');
    let FloatationBall = generateImageUrl('images/Module1Images/Reward_BeachBall.svg');
    let FloatationInnerTube = generateImageUrl('images/Module1Images/Reward_Floaty.svg');
    let SeashellsRed = generateImageUrl('images/Module1Images/Reward_StarFish.svg');
    let SeashellsGreen = generateImageUrl('images/Module1Images/Reward_Shell.svg');
    let MermaidBlue = generateImageUrl('images/Module6Images/DailyReward_Mermaid1.png');
    let MermaidRed = generateImageUrl('images/Module6Images/DailyReward_Mermaid2.png');
    let ClamBlue = generateImageUrl('images/Module6Images/DailyReward_BluePearl.png');
    let ClamPink = generateImageUrl('images/Module6Images/DailyReward_PinkPearl.png');
    let SeaweedGreen = generateImageUrl('images/Module6Images/DailyReward_SeaweedGreen@3x.png');
    let SeaweedBrown = generateImageUrl('images/Module6Images/DailyReward_SeaweedBrown@3x.png');
    let CrabwearGlasses = generateImageUrl('images/Module1Images/Reward_Glasses.svg');
    let CrabWearMustash = generateImageUrl('images/Module1Images/Reward_Mustache.svg');
    let SandCastle = generateImageUrl('images/Module6Images/BigReward_InsideCir_Castle.svg');
    let Treasure = generateImageUrl('images/Module6Images/BigReward_Treasure.svg');

    let greenCheck = generateImageUrl('images/Module1Images/GreenCheck-Button.png');
    let SingingTimeIcon = generateImageUrl('images/Module1Images/Button_SingingTime.png');
    let AfterCelebrateVideo9 = "8338f6e6d4e5093c5c4cc6bc19ab/480.m3u8"
    let present = generateImageUrl('images/Images/Gift.png');

    let [chestopen, setChestOpen] = useState(closedChest6);
    let [reviewIcon, setReviewIcon] = useState(false);
    let [keyIcon, setKeyIcon] = useState(false);
    let [coinIcon, setCoinIcon] = useState(false);
    let [presentIcon, setPresentIcon] = useState(false);
    let [rewardOption1, setRewardOption1] = useState(null);
    let [rewardOption2, setRewardOption2] = useState(null);
    let [displayReward, setDisplayReward] = useState(false);

    let [displayLearn, setDisplayLearn] = useState(false);
    let [displayPractice, setDisplayPractice] = useState(false);
    let [displayDay4Practice, setDisplayDay4Practice] = useState(false);
    let [displaySingingTime, setDisplaySingingTime] = useState(false);
    let [displayCelebrate, setDisplayCelebrate] = useState(false);
    let [displaybody, setDisplayBody] = useState(true);
    let [displayGreenButton, setdisplayGreenButton] = useState(false);
    let [learn, setLearn] = useState('');
    let [singTime, setSingTime] = useState('');
    let [day4Practice, setDay4Practice] = useState('');
    let [celebrate, setCelebrate] = useState('');
    const firstUpdate = useRef(true);
    const coinUpdate = useRef(true);
    let [displayIntroVideo, setDisplayIntroVideo] = useState(false);
    let [introVideo, setIntroVideo] = useState('');
    let [displaySurprise, setDisplaySurprise] = useState(false);
    let [surpriseVideo, setSurpriseVideo] = useState(false);    
    let [displayVoice, setDisplayVoice] = useState(false);
    let [animalVoice, setAnimalVoice] = useState('');
    let [prize, setPrize] = useState(false);
    let [disPlayPrize, setDisplayPrize] = useState(false);
    let [checkStep, setCheckStep] = useState('');
    
    let keys5 = [progressbar0, progressbar1, progressbar2, progressbar2, progressbar3, progressbarCompleted]
    let keys4 = [progressbar0, progressbar1, progressbar2, progressbar3, progressbarCompleted]

    let [touchButton, setTouchButton] = useState(false);
    let [checkSound, setCheckSound] = useState(false);
    let [buttonSound, setButtonSound] = useState(false);
    let [rewardsFound, setRewardsFound] = useState(false);
    let [keyAnimationState, setKeyAnimationState] = useState('')
    let [coinAnimationState, setCoinAnimationState] = useState('bounceIcons')
    let [coinAudio, setCoinAudio] = useState(false)
    let [playChestOpen, setPlayChestOpen] = useState(false);
    let [playChestShake, setPlayChestShake] = useState(false);
    let [chestAnimationState, setChestAnimationState] = useState('')
    let [showCrab, setShowCrab] = useState(false);
    let [crabState, setCrabState] = useState('');
    let [playYouAreAwesome, setPlayYouAreAwesome] = useState(false);
    let [displayFTB, setDisplayFTB] = useState(false);
    let [showReward, setShowReward] = useState(false);

    let [ftbMusic, setFTBMusic] = useState('')
    let [ftbInstruction, setFTBInstruction] = useState('');
    let [ftbInstructionGIF, setFTBInstructionGIF] = useState('');
    let [ftbCount, setFTBCount] = useState('');
    let [ftbTutorial1, setFTBTutorial1] = useState('');
    let [ftbTutorial2, setFTBTutorial2] = useState('');
    let [ftbWT, setFTBWalkThrough] = useState('');

    let [dayFinished, setDayFinished] = useState('');
    let [ftbIntro, setFtbIntro] = useState('');
    let [practiceIntro, setPracticeIntro] = useState('');
    let [learnIntro, setLearnIntro] = useState('');
    let [awesomeJob, setAwesomeJob] = useState('');
    let [audioReady, setAudioReady] = useState(false);
    let [celebrateIntro, setCelebrateIntro] = useState('');
    let [closingGIF, setClosingGIF] = useState('');
    let [practiceMessage, setPracticeMessage] = useState('');
    let [practiceConversation, setPracticeConversation] = useState('');
    let influencers = [login.influencerid, login.influencerid1,login.influencerid2,login.influencerid3,login.influencerid4]
    const touchSound = new Audio(generateImageUrl('media/Module1Videos/touch_button.mp3'))
    

    function getGifs() {
        setAwesomeJob(getVideo('appfiles/greet/greet_awesome_job.gif', login));

        setFTBCount(getVideo('appfiles/greet/countingCrab.gif', login));

        setPracticeIntro(getVideo('appfiles/greet/greet_practice_intro.gif', login));

        setLearnIntro(getVideo('appfiles/greet/greet_learn_intro.gif', login));

        setFtbIntro(getVideo('appfiles/greet/ftb_intro.gif', login));

        setCelebrateIntro(getVideo('appfiles/greet/greet_celebrate_intro.gif', login));

        setFTBInstruction(getVideo('appfiles/feelings/feelings_ftb_instructions.mp3', login));

        setFTBInstructionGIF(getVideo('appfiles/greet/ftb_crab_instructions.gif', login));

        setFTBMusic(getVideo('appfiles/feelings/ftb greet with clapping.m4a', login));

        setClosingGIF(getVideo('appfiles/feelings/feelings_closing.gif', login));

        setDayFinished(getVideo('appfiles/feelings/feelings_day_finished.mp3', login));

        setPracticeMessage(getVideo('appfiles/greet/greet_special_message.gif', login));

        setPracticeConversation(getVideo('appfiles/greet/practice_watch_conversation.gif', login));

        if (!module11.unlockedDays.day2) {
            setFTBTutorial1(getVideo('appfiles/feelings/ftb_walkthrough_touch.mp3', login));

            setFTBTutorial2(getVideo('appfiles/feelings/ftb_walkthrough_clap.mp3', login));

            setFTBWalkThrough(getVideo('appfiles/greet/ftb_walkthrough_audio.mp3', login));
        }
    }

    useEffect(() => {
        getGifs()
    }, []);


    function sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    const createGameDetails = (flag,reward,coin) =>{
        let game_detail = module11.game_details
        if(flag){
            let flags = {flag:flag, lastUpdated:(new Date()).toJSON()}
            game_detail.moduleFlags.push(flags)
        }
        if(coin >= 0){
            game_detail.tokens_earned = coin
        }
        if (reward){
            let dailyRewards = []
            for (let key in  module11.rewards) {
                if(module11.rewards[key].unlocked === true){
                    let rewards = {type: key, x_multiplier: module11.rewards[key].x, y_multiplier: module11.rewards[key].y}
                    dailyRewards.push(rewards)
                }
            }
            game_detail.dailyRewards=dailyRewards
        }
        dispatch({ type: 'MODULE11_SET_GameDetials', payload: game_detail })
    }

    const updateProgress = (async () => {
		const payload = {
			body: {
				id: login.studentid,
				module: "Feelings",
				day_completed: module11.currentday,
				time_completed: new Date().toDateString(),
			},
		}
		await API.put('TIR', '/v3/student/progress', payload)
		.then((response) => {
		})
		.catch((error) => {
		});
	})

    const updateDB = async () => {
        const myInit = {
            body:{ id: module11.moduleID, day_completed: module11.day_completed, step_completed: module11.stepCompleted, game_details: JSON.stringify(module11.game_details)}
        };
        await API.put("TIR", "/v3/student/module", myInit)
        .then(response => {
            if(displayGreenButton){
                setAnimalVoice(null)
                setCrabState(closingGIF);
                setShowCrab(true)
                setPlayYouAreAwesome(true);
                setdisplayGreenButton(false);
                setDisplayReward(false);
            }
        })
        .catch(error => {
            if(module11.stepCompleted === "notstarted" ||  module11.stepCompleted === "learn" || module11.stepCompleted === "practice"  || module11.stepCompleted === "celebrate" || module11.stepCompleted === "followthebeat" ){
                window.alert("Connection is lost. Please login again.");
                dispatch({type: 'CLEAR'}); 
                Auth.signOut();
                navigate('/')
            }
        });
        const myInit2 = {
            body: {
              id: login.studentid,
              current_module: 'Feelings',
            },
          };
        await API.put('TIR', '/v3/student', myInit2)
        .then((response) => {
        })
        .catch((error) => {
        });
    }

    useEffect(() => {
        if (firstUpdate.current) {
            firstUpdate.current = false;
        }else {
            if(login.grade !== "Teacher Mode" && login.grade !== 'Free Play'){
                updateDB();
            }
          }
    }, [module11.stepCompleted]);

    useEffect(() => {
        if((module11.reviewIcon === true || login.grade === "Teacher Mode") && module11.sectionCompleted === 4 ) {
            updateProgress();
            module11.sectionCompleted = 0;
        }
    }, [module11.sectionCompleted])

    useEffect(() => {
        if(module11.coins >= 100){setPrize(true)}
        if (coinUpdate.current) {
            coinUpdate.current = false;
        }else {
            createGameDetails(false, false,module11.coins);
            updateDB();
          }
    }, [module11.coins]);

    const togglePopup = () => {
        setIsOpen(!isOpen);
    }

    useEffect(() => {
        if (module11.currentday <= module11.day_completed || login.grade === "Teacher Mode"  || login.grade === "Free Play"){
            if(login.grade === "Teacher Mode" || login.grade === "Free Play"){
                setShowReward(true)
            }
            dispatch({ type: 'MODULE11_TOGGLE_REVIEW_ICON', payload: true })
            dispatch({ type: 'MODULE11_SET_KEY', payload: 4})
            if(module11.currentday == 4 || module11.currentday == 8){
                dispatch({ type : 'MODULE11_SET_KEY', payload:5})
            }
        }
        else{
            if (module11.stepCompleted === checkStep){setCoinIcon(true)}
            dispatch({ type: 'MODULE11_TOGGLE_REVIEW_ICON', payload: false })
            if (module11.currentday === 4 && module11.day_completed === 3) {
                if (module11.stepCompleted === "notstarted") {
                    dispatch({ type: 'MODULE11_SET_KEY', payload: 0})

                }
                else if (module11.stepCompleted === "singingtime") {
                    dispatch({ type: 'MODULE11_SET_KEY', payload: 1 })
  
                }
                else if (module11.stepCompleted === "learn") {
                    dispatch({ type: 'MODULE11_SET_KEY', payload: 2 })

                }
                else if (module11.stepCompleted === "practice") {
                    dispatch({ type: 'MODULE11_SET_KEY', payload: 3}) 

                }
                else if (module11.stepCompleted === "followthebeat") {dispatch({ type: 'MODULE11_SET_KEY', payload: 4 }) }
                else if (module11.stepCompleted === "celebrate"){setKeyIcon(true); dispatch({ type: 'MODULE11_SET_KEY', payload: 5}) }
                playButtonAudio()
            } 
            else {
                if (module11.stepCompleted === "notstarted") {
                    dispatch({ type: 'MODULE11_SET_KEY', payload: 0 }) 

                }
                else if (module11.stepCompleted === "learn") {
                    dispatch({ type: 'MODULE11_SET_KEY', payload: 1 })
       
                }
                else if (module11.stepCompleted === "practice") {
                    dispatch({ type: 'MODULE11_SET_KEY', payload: 2 }) 

                }
                else if (module11.stepCompleted === "followthebeat") {
                    dispatch({ type: 'MODULE11_SET_KEY', payload: 3 })

                }
                else if (module11.stepCompleted === "celebrate"){
                    if (module11.currentday === 8 && module11.day_completed === 7)  {
                        dispatch({ type: 'MODULE11_SET_KEY', payload: 4}) 
                        setPresentIcon(true)
                    }
                    else{
                        setKeyIcon(true); dispatch({ type: 'MODULE11_SET_KEY', payload: 4}) 
                    }
                }
                else if (module11.stepCompleted === "surprise"){
                    dispatch({ type: 'MODULE11_SET_KEY', payload: 5}) 
                    setKeyIcon(true)
                }
                playButtonAudio()
            }
        }
    }, [module11.stepCompleted]);
    
    let [displayGreenCheck, setDisplayGreenCheck] = useState(false);
    let [dropZone, setDropZone] = useState(false);

    let selectReward = () => {
        return (
            <>
                <div className='rewards' id ='rewardList'>
                    <div className='circle' id='rewardItemLeft'>
                        <img src={rewardOption1} alt="" onClick={() => { dispatch({ type: `MODULE11_SET_REWARD${module11.currentday}1`, payload: true }); dispatch({ type: `MODULE11_SET_REWARD${module11.currentday}2`, payload: false }); document.getElementById("rewardItemLeft").style.borderColor = 'yellow'; document.getElementById("rewardItemRight").style.borderColor = 'white'; setTouchButton(true); setDisplayGreenCheck(true)}} />
                    </div>
                    <div className='circle' id='rewardItemRight'>
                        <img src={rewardOption2} alt="" onClick={() => { dispatch({ type: `MODULE11_SET_REWARD${module11.currentday}2`, payload: true }); dispatch({ type: `MODULE11_SET_REWARD${module11.currentday}1`, payload: false }); document.getElementById("rewardItemRight").style.borderColor = 'yellow'; document.getElementById("rewardItemLeft").style.borderColor = 'white'; setTouchButton(true); setDisplayGreenCheck(true) }} />
                    </div>
                </div>
                <div className='greenCheckDiv'>
                    {displayGreenCheck && <img className='greenCheck' src={greenCheck} alt="" onClick={() => { 
                        document.getElementById("rewardList").style.zIndex = 1;
                        setCheckSound(true);
                        setDropZone(true);
                        setDisplayGreenCheck(false);
                        setdisplayGreenButton(true);
                    }}/>}
                </div>
                {dropZone && <div class="area">
                    <div id="dropZone">Drag and drop your item</div>
                </div>}
                <div className='greenCheckDiv'>
                    {displayGreenButton && <img className='greenCheck' src={greenCheck} alt="" onClick={() => { 
                        setCheckSound(true);
                        setDropZone(false);
                        updateProgress();
                        sleep(500).then(() => {
                            createGameDetails(false, true, module11.coins); 
                            if(login.grade === "Teacher Mode" || login.grade === "Free Play"){
                                updateDB();
                            }
                            dispatch({ type: `MODULE11_SET_DAY_UNLOCK${(module11.currentday + 1)}`, payload: true }); 
                            dispatch({ type: 'MODULE11_SET_dayCompleted', payload: module11.currentday === 8 ? 9 : module11.currentday}); 
                            dispatch({type: 'MODULE11_SET_stepCompleted' ,payload: "notstarted"}); 
              
                        })
                    }}/>}
                </div>
            </>
        )

    }
    let openPrize = () => {
        return (
            <>
                <div className='rewards'>
                    <div className='circle' id='rewardItemLeft'>
                        <img src={SandCastle} alt="" onClick={() => { dispatch({ type: `MODULE11_SET_PRIZE1`, payload: true }); dispatch({ type: `MODULE11_SET_PRIZE2`, payload: false }); document.getElementById("rewardItemLeft").style.borderColor = 'yellow'; document.getElementById("rewardItemRight").style.borderColor = 'white'; setTouchButton(true); setDisplayGreenCheck(true)}} />
                    </div>
                    <div className='circle' id='rewardItemRight'>
                        <img src={Treasure} alt="" onClick={() => { dispatch({ type: `MODULE11_SET_PRIZE2`, payload: true }); dispatch({ type: `MODULE11_SET_PRIZE1`, payload: false }); document.getElementById("rewardItemRight").style.borderColor = 'yellow'; document.getElementById("rewardItemLeft").style.borderColor = 'white'; setTouchButton(true); setDisplayGreenCheck(true) }} />
                    </div>
                </div>
                <div className='greenCheckDiv'>
                    {displayGreenCheck && <img className='greenCheck' src={greenCheck} alt="" onClick={() => { 
                        setCheckSound(true);
                        setDropZone(true);
                        setDisplayGreenCheck(false);
                        setdisplayGreenButton(true);
                    }}/>}
                </div>
                {dropZone && <div class="area">
                    <div id="dropZone">Drag and drop your item</div>
                </div>}
                <div className='greenCheckDiv'>
                    {displayGreenButton && <img className='greenCheck' src={greenCheck} alt="" onClick={() => { 
                        setDisplayPrize(false);
                        setCheckSound(true);
                        setDropZone(false);
                            sleep(500).then(() => {
                                setdisplayGreenButton(false);
                                createGameDetails(false, true);
                                dispatch({type: 'MODULE11_SET_COIN' ,payload: module11.coins - 100})
                                setChestOpen(closedChest6);
                                setPlayChestOpen(false);
                        })}}/>}
                </div>
            </>
        )

    }

    useEffect(() => {
        switch (module11.currentday) {
            case 1:
                setRewardOption1(SurfBoardRed); setRewardOption2(SurfBoardBlue); break;
            case 2:
                setRewardOption1(CoralBlue); setRewardOption2(CoralRed); break;
            case 3:
                setRewardOption1(FloatationInnerTube); setRewardOption2(FloatationBall); break;
            case 4:
                setRewardOption1(SeashellsRed); setRewardOption2(SeashellsGreen); break;
            case 5:
                setRewardOption1(MermaidRed); setRewardOption2(MermaidBlue); break;
            case 6:
                setRewardOption1(ClamBlue); setRewardOption2(ClamPink); break;
            case 7:
                setRewardOption1(SeaweedBrown); setRewardOption2(SeaweedGreen); break;
            case 8:
                setRewardOption1(CrabwearGlasses); setRewardOption2(CrabWearMustash); break;
            default:
                setdisplayGreenButton(true);
                break;
        }
    }, [keyIcon]);

    const displayReview = () => {
        if (module11.currentday === 4){
            return (
                <>
                    <div className='world2reviewContainer'>
                        <img
                        className='reviewBtns41'
                        src={SingingTimeIcon}
                        alt='singing button'
                        onClick={() => {
                            displaySinging();
                        }}
                        />
                        <img
                        className='reviewBtns42'
                        src={learnBtn}
                        alt='learn button'
                        onClick={() => {
                            openLearn();
                        }}
                        />
                        <img
                        className='reviewBtns43'
                        src={practiceBtn}
                        alt='practice button'
                        onClick={() => {
                            openPractice();
                        }}
                        />
                        <img
                        className='reviewBtns44'
                        src={ftbBtn}
                        alt='ftb button'
                        onClick={() => {
                            openFTB();
                        }}
                        />
                        <img
                        className='reviewBtns45'
                        src={celebrateBtn}
                        alt='celebrate button'
                        onClick={() => {
                            openCelebrate();
                        }}
                        />
                    </div>
                </>
            )
        }
        else{
            return (
                <>
                    <div className='world2reviewContainer'>
                        <img className='reviewBtns1' src={learnBtn} alt="learn button" onClick={() => { openLearn() }} />
                        <img className='reviewBtns2' src={practiceBtn} alt="practice button" onClick={() => { openPractice(); }} />
                        <img className='reviewBtns3' src={ftbBtn} alt="ftb button" onClick={() => { openFTB() }} />
                        <img className='reviewBtns4' src={celebrateBtn} alt="celebrate button" onClick={() => { openCelebrate() }} />
                    </div>
                </>
            )
        }

    }

    const introduction= () => { 
        return (
            <div>
                <CloudfrontVideoFormat source={introVideo} back='/feelings/navigation' background={background} token={login.cookie} ended={() => {
                    //here is where you can add dispatch functions
                    setDisplayIntroVideo(false);
                    setDisplayBody(true);
                    if(module11.currentday === 4){
                        dispatch({ type: 'MODULE11_SET_KEY', payload: 1})
                        playButtonAudio();
                    }
                    if(module11.day_completed === 9){
                        navigate("/feelings/navigation")
                    }  
                }}/>
            </div>
        )
    }

    const openLearn = async ()=>{
        let song = getVideo("appfiles/feelings/feelings_demo.m4a", login);
        let video = getVideo("appfiles/feelings/learn_video.mp4", login);
        
        switch (module11.currentday) {
            case 1:
                setLearn(
                    <Learn video="af6addb49d098d7052ee260834b1/480.m3u8"
                        songVideo={video} closingVideo="979516c071834a384e6e9a022f28/480.m3u8"
                        destiny="/feelings" song={song} back="/feelings" background={background} setDisplayLearn={setDisplayLearn}
                        step_completed="MODULE11_SET_stepCompleted" module={module11}
                    />
                )
                break;
            case 2:
                setLearn(
                    <Learn video="51f4b4e5e4bd1dc5aac4c626a563/480.m3u8"
                        songVideo={video} closingVideo="e37c31378ff6c2d3301507dcf535/480.m3u8"
                        destiny="/feelings" song={song} back="/feelings" background={background} setDisplayLearn={setDisplayLearn}
                        step_completed="MODULE11_SET_stepCompleted" module={module11}
                    />
                )
                break;
            case 3:
                setLearn(
                    <Learn video="610cd2227ca26f5ad3c2cbd0d275/480.m3u8"
                        songVideo={video} closingVideo="ede27497e3530e9b95fa433577f2/480.m3u8"
                        destiny="/feelings" song={song} back="/feelings" background={background} setDisplayLearn={setDisplayLearn}
                        step_completed="MODULE11_SET_stepCompleted" module={module11}
                    />
                )
                break;
            default:
                setAnimalVoice(getVideo("appfiles/feelings/feelings_learn_intro.mp3", login))
                //setDisplayVoice(true)
                // setCrabState(learnIntro);
                // setShowCrab(true);
                await GetUserVideo(`userfiles/${module11.StudentID}/feelings_play_day_music.m4a`).then(data => {
                    fetch(data).then(response => {
                        GetUserVideo(`influencers/${influencers[module11.currentday-4]}/greet_affirmation.mp4`).then(influencerVideo => {
                            if(response.status === 200){
                                setLearn(
                                    <Learn songVideo={video} destiny="/feelings" song={data} back="/feelings" 
                                        background={background} setDisplayLearn={setDisplayLearn}
                                        step_completed="MODULE11_SET_stepCompleted" module={module11}
                                        instrumental={getVideo("appfiles/feelings/feelings_octopus.m4a", login)} influencerVideo={influencerVideo}
                                    />
                                )
                            }
                            else{
                                setLearn(
                                    <Learn songVideo={video} destiny="/feelings" song={song} back="/feelings" 
                                        background={background} setDisplayLearn={setDisplayLearn}
                                        step_completed="MODULE11_SET_stepCompleted" module={module11}
                                        influencerVideo={influencerVideo}
                                    />
                                )
                            }
                        })
                    })
                })
                break;
        }
        setDisplayLearn(true)
    }

    const openPractice = async () =>{
        setDisplayPractice(true)
    }

    const openFTB = async ()=>{
        // switch(module11.currentday){
        //     case 1:
        //         break;
        //     case 2:
        //         break;
        //     case 3:
        //         break;
    
        //     default:
        //         setCrabState(ftbIntro)
        //         setAnimalVoice(getVideo("appfiles/feelings/feelings_ftb_intro.mp3", login))
        //         //setDisplayVoice(true)
        //         setShowCrab(true)
        //         break;
        // }
        setDisplayFTB(true)
    }

    const openCelebrate = async ()=>{
        let celebrateVideo1 = "f740080030fdc3f5dc43a1ee243d/480.m3u8"
        let celebrateVideo2 = "100c9b7f28b31b314a231700edce/480.m3u8"
        let celebrateVideo3 = "Module11/celebrate_day3.mp4"

        switch (module11.currentday) {
            case 1:
                setCelebrate(<Celebrate  module={module11} celebrateVideo={celebrateVideo1} background={background} setDisplayCelebrate={setDisplayCelebrate} moduleNum={"MODULE11"}/>)
                break;
            case 2:
                setCelebrate(<Celebrate  module={module11} celebrateVideo={celebrateVideo2} background={background} setDisplayCelebrate={setDisplayCelebrate} moduleNum={"MODULE11"}/>)
                break;
            case 3:
                setCelebrate(<Celebrate  module={module11} celebrateVideo={celebrateVideo3} background={background} setDisplayCelebrate={setDisplayCelebrate} moduleNum={"MODULE11"}/>)
                break;
            default:
                // setCrabState(celebrateIntro)
                // setShowCrab(true)
                // setAnimalVoice(getVideo("appfiles/greet/greet_celebrate_intro.mp3", login))
                //setDisplayVoice(true)
                let voice1 = getVideo("appfiles/greet/greet_celebrate_record_awesome.mp3", login)
                let voice2 = getVideo("appfiles/greet/greet_celebrate_say_thanks.mp3", login)
                let voice3 = getVideo("appfiles/eye_contact/crab_awesome_job.mp3", login)
                let animalGIF = getVideo('appfiles/feelings/feelings_joyful.gif', login)
                let animalVoice = getVideo('appfiles/feelings/feelings_joyful_jingle_intro.mp3', login)
                await GetUserVideo(`influencers/${influencers[module11.currentday-4]}/greet_affirmation.mp4`).then(influencerVideo => {
                    setCelebrate(<Celebrate  module={module11} background={background} voice1={voice1} voice2={voice2} voice3={voice3}
                                            animalGIF={animalGIF} animalVoice={animalVoice}
                                            text={"Record yourself in an excited voice and say, \"I am awesome!\""}
                                            name={`feelings_celebration_surprise_${module11.currentday+1}.mp4`}
                                            influencerVideo={influencerVideo} animation={awesomeJob} world3={true}
                                            animal={animal} setDisplayCelebrate={setDisplayCelebrate} moduleNum={"MODULE11"}/>)              
                })
                break;
        }
        setDisplayCelebrate(true)
    }
    
    const displaySinging = async () =>{
        let introVideo = "70eafeccd6c1f7c43050ccaac8ed/480.m3u8"
        let noteVideo = getVideo("appfiles/feelings/feelings_student_notes.mp4", login)
        let singingMusic = getVideo("appfiles/feelings/feelings_demo.m4a", login)
        let instrumental = getVideo("appfiles/feelings/feelings_instrumental.m4a", login)
        setSingTime(<SingingTime introVideo={introVideo} demoMusic={singingMusic} singingVideo={noteVideo} background={background}
            singingMusic = {singingMusic} setDisplaySingingTime={setDisplaySingingTime} 
            module={module11} moduleNum ="MODULE11" name="feelings" instrumental={instrumental} instrumentalURL={"appfiles/feelings/feelings_octopus.m4a"}/>)
        setDisplaySingingTime(true)
    }

    let getSurprise = async ()=>{
        let usePhoto = [
            {
                video: `influencers/${login.influencerid}/greet_affirmation.mp4`,
            },
            {
                video: `userfiles/${module11.StudentID}/feelings_celebration_surprise_5.mp4`,
            },
            {
                video: `influencers/${login.influencerid1}/greet_affirmation.mp4`,
            },
            {
                video: `userfiles/${module11.StudentID}/feelings_celebration_surprise_8.mp4`,
            },
            {
                video: `influencers/${login.influencerid2}/greet_video_message.mp4`,
            },
            {
                video: `influencers/${login.influencerid3}/greet_affirmation.mp4`,
            },
            {
                video: `userfiles/${module11.StudentID}/feelings_celebration_surprise_9.mp4`,
            },
            {
                video: `influencers/${login.influencerid4}/greet_affirmation.mp4`,
            }
        ]
        
        for (let i = 0; i < usePhoto.length; i++) {
            await GetUserVideo(usePhoto[i].video, login).then((data) => {
              usePhoto[i].video = data;
            });
        }
        
        return usePhoto;
    }

    const playSurpriseVideo = async ()=>{
        await getSurprise().then(photo => {
            setSurpriseVideo(<Surprise background={background} music={getVideo("appfiles/feelings/feelings_instrumental.m4a", login)}
                animal={animal} back={"/"} slides={photo} setDisplaySurprise={setDisplaySurprise}/>)
        })

        setDisplaySurprise(true)
        setKeyIcon(true)
        setPresentIcon(false)
    }

    const coinAnimation = () => {
        setCoinAnimationState("coinAnimation")
        setCoinAudio(true);
    }

    const keyAnimation = () => {
        setKeyAnimationState('fade-out')
        sleep(1000).then(() => {
            chestShakeAnimation();
        })
    } 

    const chestShakeAnimation = () => {
        setChestAnimationState('shakeChest');
        setPlayChestShake(true);
        sleep(1400).then(() => {
            setKeyIcon(false); 
            setChestOpen(openChest);
            setPlayChestOpen(true);
            rewardsMovingAnimation();
        })
    }

    const rewardsMovingAnimation = () => {
        sleep(1000).then(() => {
            setDisplayReward(true);
        })
    }


    const closeDay8Video = () => {
        setIntroVideo(AfterCelebrateVideo9);
        setDisplayIntroVideo(true); 
        setDisplayBody(false); 
        setShowCrab(false);
    }

    const playButtonAudio = () => {
        sleep(700).then(() => {
            setButtonSound(true)
        })
    }

    const onStop = (reward, data) => {
        let position ={x: data.x/clientWidth, y:data.y/clientHeight}
        if(reward === 1 || reward === 2){
            dispatch({ type: `MODULE11_SET_PRIZE${reward}_POSITION`, payload: position })
        }
        else{
            dispatch({ type: `MODULE11_SET_REWARD${reward}_POSITION`, payload: position })
        }

    }

    return (
        <>
        {playYouAreAwesome && <audio autoPlay onPlay={()=>{setAudioReady(true)}} onEnded={() => (module11.currentday === 8 ? closeDay8Video() : navigate("/feelings/navigation"))} onError={() => (module11.currentday === 8 ? closeDay8Video() : navigate("/feelings/navigation"))}>
            <source src={dayFinished} ></source>
        </audio>}
        
        {coinAudio && <audio autoPlay onEnded={() => {
            dispatch({type: 'MODULE11_SET_COIN' ,payload: module11.coins + 1})
            setCoinAudio(false);
            setCoinAnimationState("bounceIcons");
            setCoinIcon(false);
            playButtonAudio();
        }} onError={() => {
            dispatch({type: 'MODULE11_SET_COIN' ,payload: module11.coins + 1})
            setCoinAudio(false);
            setCoinAnimationState("bounceIcons");
            setCoinIcon(false);
            playButtonAudio();
        }}>
            <source src={generateImageUrl('media/Module5Videos/earn_token.mp3')} type="audio/mp3"/>    
        </audio>}
        {checkSound && <audio autoPlay onEnded={() => {
            setCheckSound(false)
        }} onError={() => {
            setCheckSound(false)
        }}>
            <source src={generateImageUrl('media/Module1Videos/button_accept_item.mp3')} type="audio/mp3"/>    
        </audio>}
        {rewardsFound && <audio autoPlay>
            <source src={generateImageUrl('media/Module2Videos/daily_rewards_present.mp3')} ></source>
        </audio>}
        {touchButton && <audio autoPlay onEnded={() => {
            setTouchButton(false)
        }} onError={() => {
            setTouchButton(false)
        }}>
            <source src={generateImageUrl('media/Module1Videos/touch_button.mp3')} type="audio/mp3"/>    
        </audio>}
        {buttonSound && <audio autoPlay onEnded={() => {
            setButtonSound(false)
        }} onError={() => {
            setButtonSound(false)
        }}>
            <source src={generateImageUrl('media/Module1Videos/button_bouncing.mp3')} type="audio/mp3"/>    
        </audio>}
        {playChestOpen && <audio autoPlay>
            <source src={generateImageUrl('media/Module1Videos/chest_open_items_out.mp3')} ></source>
        </audio>}

        {playChestShake && <audio autoPlay>
            <source src={generateImageUrl('media/Module1Videos/chest_shake.mp3')} ></source>
        </audio>}

        {displayVoice && <audio autoPlay onPlay={()=>{setAudioReady(true)}} onEnded={() => {
            //setCrabState(crab)
            setAudioReady(false)
            setShowCrab(false)
            setDisplayVoice(false)
        }} onError={() => {
            setAudioReady(false)
            setShowCrab(false)
            setDisplayVoice(false)
        }}> 
            <source src={animalVoice}></source>
        </audio>}
        {displayIntroVideo && introduction()}
        {!showCrab && displayLearn && learn}
        {displayPractice && <Practice setDisplayPractice={setDisplayPractice} background={background} stepComplete={'MODULE11_SET_stepCompleted'} module={module11} practiceConversation={practiceConversation} practiceMessage={practiceMessage} awesomeJob={awesomeJob}/>}
        {!showCrab && displayFTB && <FollowTheBeatModule6 setDisplayFTB={setDisplayFTB} awesomeJob={awesomeJob} instruction={ftbInstruction} instructionGIF={ftbInstructionGIF} song={ftbMusic} count={ftbCount} tutorial1={ftbTutorial1}
          tutorial2={ftbTutorial2} walkthrough={ftbWT} stepComplete={'MODULE11_SET_stepCompleted'} module={module11} unit3={true} score={'ftb_feelings'}/>}
        {displaySingingTime && singTime}
        {!showCrab && displayCelebrate && celebrate}
        {displaySurprise && surpriseVideo} 
        {((displaybody && !displayLearn && !displayPractice && !displaySingingTime && !displayCelebrate && !displaySurprise && !displayFTB && !displayDay4Practice) || showCrab) &&
        <div className='feelingsWorldBody' style={{backgroundImage: `url(${background})`}}>
            <div className='navigation'>
                <img className="logoutBtn" src={logoutBtn} alt="Logout Button" onClick={togglePopup} />
                <img className="JourneyBlueImage" src={journeyImage} alt="Navigation blue world Image" onClick={() => { navigate("/feelings/navigation") }} />
            </div>
            {isOpen && <PopUp
                content={<>
                    <b id='title'>Are you sure you want to leave?<br/></b>
                    <button id='logoutButton1' className='logoutButton' onClick={() => { navigate("/"); userHasAuthenticated(false); localStorage.setItem('token', 'false');}}>YES</button>
                    <button id='logoutButton2' className='logoutButton' onClick={togglePopup}>NO</button>
                </>
                }
                handleClose={togglePopup}
            />}

            {prize && <audio autoPlay> 
                <source src={presentSound}></source>
            </audio>}

            {prize && <img className='prize' src={generateImageUrl('images/Images/prize.png')} alt="Logout Button" onClick={()=>{
                        setPrize(false)
                        setChestAnimationState('shakeChest');
                        setPlayChestShake(true);
                        sleep(1400).then(() => {
                            setChestOpen(openChest);
                            setPlayChestOpen(true);
                            sleep(1000).then(() => {
                                setDisplayPrize(true)
                            })
                        })}} />}
            {prize && <button className='prize-button' onClick={()=>{
                    setPrize(false)
                    setDisplayPrize(true)
            }}> <h5>Click Here</h5></button>}
            {disPlayPrize && openPrize()}

            <img className="animateCrab11" src={crab} alt="crab Icon" />
            {showCrab && !audioReady && <img id="loading"  src={loading}/>}
            {showCrab && <img className="animateCrab11" style={(audioReady) ? {} : { display: 'none' }}  src={crabState} onLoad={()=>(setDisplayVoice(true))} onError={()=>(setShowCrab(false))}></img>}
            <img className="closedChest6" src={chestopen} id={chestAnimationState} alt="closed Chest Icon" />

            <div className='scoreBar'>
                <img className="scoreKey" src={coinBar} alt="crab Icon" />
                {module11.coins < 10 && <h5 className='scoretext1' >{module11.coins}</h5>}
                {module11.coins >= 10  && module11.coins < 100 && <h5 className='scoretext10' >{module11.coins}</h5>}
                {module11.coins >= 100 && <h5 className='scoretext100' >{module11.coins}</h5>}
                <p className='scoretext' >100</p>
            </div>

            {(module11.currentday === 4 || module11.currentday === 8) ? (<div className='progressBar'>
                <img className="progressKey" src={keys5[module11.keys]} alt="crab Icon" />
                <h3 className='progresstext' >{module11.keys}/5</h3>
            </div>) : (<div className='progressBar'>
                <img className="progressKey" src={keys4[module11.keys]} alt="crab Icon" />
                <h3 className='progresstext' >{module11.keys}/4</h3>
            </div>)}
                
            {!showCrab && !module11.reviewIcon && !coinIcon && !disPlayPrize && !dropZone && <div className='actionBtnDiv'>
                
                {(module11.currentday === 4) && (module11.stepCompleted === "notstarted") && <img className='actionBtn2' id="bounceIcons" src={SingingTimeIcon} alt="learn button" onClick={() => { setTouchButton(true); sleep(500).then(() => { displaySinging(); setCheckStep('singingtime')}) }} />}
                {(module11.currentday !== 4) && (module11.stepCompleted === "notstarted") && <img className='actionBtn2' id="bounceIcons" src={learnBtn} alt="learn button" onClick={() => { setTouchButton(true); sleep(500).then(() => { openLearn(); setCheckStep('learn')}) }} />}

                {module11.stepCompleted === "learn" && <img className='actionBtn2' id="bounceIcons" src={practiceBtn} alt="practice button" onClick={() => { touchSound.play(); sleep(500).then(() => {openPractice(); setCheckStep('practice')})}} />}
                {(module11.stepCompleted === "practice")&& <img className='actionBtn2' id="bounceIcons" src={ftbBtn} alt="celebrate button" onClick={() => { setTouchButton(true); sleep(500).then(() => {openFTB(); setCheckStep('followthebeat')})}} />}
                {(module11.stepCompleted === "followthebeat")&& <img className='actionBtn2' id="bounceIcons" src={celebrateBtn} alt="celebrate button" onClick={() => { setTouchButton(true); sleep(500).then(() => {openCelebrate(); setCheckStep('celebrate') })}} />}
                {module11.stepCompleted === "singingtime" && <img className='actionBtn2' id="bounceIcons" src={learnBtn} alt="singing button" onClick={() => { setTouchButton(true); sleep(500).then(() => {openLearn(); setCheckStep('learn')})}} />}
            </div>}

            {!displayVoice && coinIcon && !disPlayPrize && <div className='actionBtnDiv'>
                {module11.reviewIcon === false && <img id={coinAnimationState} src={coinPick} alt="reward key" style={{position: 'absolute', top: '50vh', left: '50vw', width: '100px', height: '100px', marginLeft: '-50px', marginTop: '-50px',zIndex:10}} onClick={() => { coinAnimation() }} />}
            </div>}

            {!disPlayPrize && !showCrab && !displayReward && (<div className='actionBtnDiv'>
                {module11.reviewIcon && (<img src={reviewBtn} className={showReward ? 'actionBtn3' : 'actionBtn2'} alt="review button" onClick={() => { setTouchButton(true); sleep(500).then(() => {setReviewIcon(!reviewIcon)}) }} />)}
                {showReward && (
                  <img
                    src={rewardBtn}
                    className='actionBtn4'
                    alt='review button'
                    onClick={() => {
                      setTouchButton(true);
                      sleep(500).then(() => {
                        keyAnimation();
                      });
                    }}
                />)}
                {module11.reviewIcon && reviewIcon && displayReview()}
            </div>)}

            {keyIcon && !coinIcon && !disPlayPrize && <img src={keyReward} id={keyAnimationState} style={{width: '150px', height: '50px', marginLeft: '-75px', zIndex:10}} className='rewardsIcon' alt="reward key" onClick={() => { keyAnimation() }} />}
            {displayReward && selectReward()}

            {!disPlayPrize && !coinIcon && presentIcon && <img className='present' style={{width: '84px', height: '100px', marginLeft: '-42px', zIndex:10}} id="bounceIcons" src={present} alt="gift" onClick={() => {playSurpriseVideo()}} />}
            {!disPlayPrize && !coinIcon && presentIcon && <audio autoPlay> 
                <source src={presentSound}></source>
            </audio>}

            <div className='rewardArea'>
                {module11.rewards.SurfBoardRed.unlocked && <Draggable
                disabled={!displayGreenButton}
                bounds="parent"
                position={{x: module11.rewards.SurfBoardRed.x * clientWidth, y: module11.rewards.SurfBoardRed.y * clientHeight}}
                onStop={(e,data)=>{onStop(11, data)}}
                ><div className='moveSurfBoard1' style={{backgroundImage: `url(${SurfBoardRed})`}}></div></Draggable>}

                {module11.rewards.SurfBoardBlue.unlocked && <Draggable
                disabled={!displayGreenButton}
                bounds="parent"
                position={{x: module11.rewards.SurfBoardBlue.x  * clientWidth, y: module11.rewards.SurfBoardBlue.y  * clientHeight}}
                onStop={(e,data)=>{onStop(12, data)}}
                ><div className='moveSurfBoard2' style={{backgroundImage: `url(${SurfBoardBlue})`}}></div></Draggable>}

                {module11.rewards.CoralBlue.unlocked && <Draggable
                disabled={!displayGreenButton}
                bounds="parent"
                position={{x: module11.rewards.CoralBlue.x * clientWidth, y: module11.rewards.CoralBlue.y * clientHeight}}
                onStop={(e,data)=>{onStop(21, data)}}
                ><div className='moveReward1' style={{backgroundImage: `url(${CoralBlue})`}}></div></Draggable>}

                {module11.rewards.CoralRed.unlocked && <Draggable
                disabled={!displayGreenButton}
                bounds="parent"
                position={{x: module11.rewards.CoralRed.x * clientWidth, y: module11.rewards.CoralRed.y * clientHeight}}
                onStop={(e,data)=>{onStop(22, data)}}
                ><div className='moveReward2' style={{backgroundImage: `url(${CoralRed})`}}></div></Draggable>}

                {module11.rewards.FloatationInnerTube.unlocked && <Draggable
                disabled={!displayGreenButton}
                bounds="parent"
                position={{x: module11.rewards.FloatationInnerTube.x * clientWidth, y: module11.rewards.FloatationInnerTube.y * clientHeight}}
                onStop={(e,data)=>{onStop(31, data)}}
                ><div className='moveReward1' style={{backgroundImage: `url(${FloatationInnerTube})`}}></div></Draggable>}

                {module11.rewards.FloatationBall.unlocked && <Draggable
                disabled={!displayGreenButton}
                bounds="parent"
                position={{x: module11.rewards.FloatationBall.x * clientWidth, y: module11.rewards.FloatationBall.y * clientHeight}}
                onStop={(e,data)=>{onStop(32, data)}}
                ><div className='moveReward2' style={{backgroundImage: `url(${FloatationBall})`}}></div></Draggable>}

                {module11.rewards.SeashellsRed.unlocked && <Draggable
                disabled={!displayGreenButton}
                bounds="parent"
                position={{x: module11.rewards.SeashellsRed.x * clientWidth, y: module11.rewards.SeashellsRed.y * clientHeight}}
                onStop={(e,data)=>{onStop(41, data)}}
                ><div className='moveReward1' style={{backgroundImage: `url(${SeashellsRed})`}}></div></Draggable>}

                {module11.rewards.SeashellsGreen.unlocked && <Draggable
                disabled={!displayGreenButton}
                bounds="parent"
                position={{x: module11.rewards.SeashellsGreen.x * clientWidth, y: module11.rewards.SeashellsGreen.y * clientHeight}}
                onStop={(e,data)=>{onStop(42, data)}}
                ><div className='moveReward2' style={{backgroundImage: `url(${SeashellsGreen})`}}></div></Draggable>}

                {module11.rewards.MermaidRed.unlocked && <Draggable
                disabled={!displayGreenButton}
                bounds="parent"
                position={{x: module11.rewards.MermaidRed.x * clientWidth, y: module11.rewards.MermaidRed.y * clientHeight}}
                onStop={(e,data)=>{onStop(51, data)}}
                ><div className='moveReward1' style={{backgroundImage: `url(${MermaidRed})`}}></div></Draggable>}

                {module11.rewards.MermaidBlue.unlocked && <Draggable
                disabled={!displayGreenButton}
                bounds="parent"
                position={{x: module11.rewards.MermaidBlue.x * clientWidth, y: module11.rewards.MermaidBlue.y * clientHeight}}
                onStop={(e,data)=>{onStop(52, data)}}
                ><div className='moveReward2' style={{backgroundImage: `url(${MermaidBlue})`}}></div></Draggable>}

                {module11.rewards.ClamBlue.unlocked && <Draggable
                disabled={!displayGreenButton}
                bounds="parent"
                position={{x: module11.rewards.ClamBlue.x * clientWidth, y: module11.rewards.ClamBlue.y * clientHeight}}
                onStop={(e,data)=>{onStop(61, data)}}
                ><div className='moveClam1' style={{backgroundImage: `url(${ClamBlue})`}}></div></Draggable>}

                {module11.rewards.ClamPink.unlocked && <Draggable
                disabled={!displayGreenButton}
                bounds="parent"
                position={{x: module11.rewards.ClamPink.x * clientWidth, y: module11.rewards.ClamPink.y * clientHeight}}
                onStop={(e,data)=>{onStop(62, data)}}
                ><div className='moveClam2' style={{backgroundImage: `url(${ClamPink})`}}></div></Draggable>}

                {module11.rewards.SeaweedBrown.unlocked && <Draggable
                disabled={!displayGreenButton}
                bounds="parent"
                position={{x: module11.rewards.SeaweedBrown.x * clientWidth, y: module11.rewards.SeaweedBrown.y * clientHeight}}
                onStop={(e,data)=>{onStop(71, data)}}
                ><div className='moveReward1' style={{backgroundImage: `url(${SeaweedBrown})`}}></div></Draggable>}

                {module11.rewards.SeaweedGreen.unlocked && <Draggable
                disabled={!displayGreenButton}
                bounds="parent"
                position={{x: module11.rewards.SeaweedGreen.x * clientWidth, y: module11.rewards.SeaweedGreen.y * clientHeight}}
                onStop={(e,data)=>{onStop(72, data)}}
                ><div className='moveReward2' style={{backgroundImage: `url(${SeaweedGreen})`}}></div></Draggable>}

                {module11.rewards.CrabwearGlasses.unlocked && <Draggable
                disabled={!displayGreenButton}
                bounds="parent"
                position={{x: module11.rewards.CrabwearGlasses.x * clientWidth, y: module11.rewards.CrabwearGlasses.y * clientHeight}}
                onStop={(e,data)=>{onStop(81, data)}}
                ><div className='moveCharaterReward1' style={{backgroundImage: `url(${CrabwearGlasses})`}}></div></Draggable>}

                {module11.rewards.CrabWearMustash.unlocked && <Draggable
                disabled={!displayGreenButton}
                bounds="parent"
                position={{x: module11.rewards.CrabWearMustash.x * clientWidth, y: module11.rewards.CrabWearMustash.y * clientHeight}}
                onStop={(e,data)=>{onStop(82, data)}}
                ><div className='moveCharaterReward2' style={{backgroundImage: `url(${CrabWearMustash})`}}></div></Draggable>}

                {module11.rewards.SandCastle.unlocked && <Draggable
                disabled={!displayGreenButton}
                bounds="parent"
                position={{x: module11.rewards.SandCastle.x * clientWidth, y: module11.rewards.SandCastle.y * clientHeight}}
                onStop={(e,data)=>{onStop(1, data)}}
                ><div className='movePrize11' style={{backgroundImage: `url(${SandCastle})`}}></div></Draggable>}

                {module11.rewards.Treasure.unlocked && <Draggable
                disabled={!displayGreenButton}
                bounds="parent"
                position={{x: module11.rewards.Treasure.x * clientWidth, y: module11.rewards.Treasure.y * clientHeight}}
                onStop={(e,data)=>{onStop(2, data)}}
                ><div className='movePrize112' style={{backgroundImage: `url(${Treasure})`}}></div></Draggable>}
            </div>

        </div>}
        </>
    )
}
export default Module11World;